import { render, staticRenderFns } from "./Errores.vue?vue&type=template&id=1cb3f0ac&lang=pug&"
import script from "./Errores.vue?vue&type=script&lang=js&"
export * from "./Errores.vue?vue&type=script&lang=js&"
import style0 from "./Errores.vue?vue&type=style&index=0&id=1cb3f0ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports